export default __webpack_public_path__ + "static/media/plus-mark.1dc79aa0.svg";